const getFlows = state => state.automationTab.flows.flows;
export default getFlows;